import { createAction, props } from '@ngrx/store';
import { FRAMSessionInfo } from '../models';

export const sessionValid = createAction(
    '[Session] Valid',
    props<{ sessionInfo: FRAMSessionInfo }>());
export const sessionInvalid = createAction('[Session] Invalid');
